import { render, staticRenderFns } from "./ToolsType.vue?vue&type=template&id=84efb994&"
import script from "./ToolsType.vue?vue&type=script&lang=js&"
export * from "./ToolsType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports